import React, { useMemo } from "react";
import { Button, Card, CardContent, InputLabel, TextareaAutosize } from "@material-ui/core";
import { useFormik } from "formik";
import { TextInput, CheckBoxInput } from "../../../../components/Forms";
import { FormGroup, ButtonWrapperFilter, FormInputWrapper, useStyles, Splitter } from "../../../../styles/common-styles";
import { useTranslation } from "react-i18next";
import PopupHeader from "../../../common-page/popupHeader";
import Tooltips from "../../../../utils/Tooltip/Tooltip";
import { postApi } from "../../../../services/apiBase";
import { toastMessage } from "../../../../utils/Message/toasts";
import { isir_update_comment_code_details } from "../../../../services/apiURL";
import { financialAid_updateISIRCommentCodeDetail } from "../../../../services/navigation_folder/financialAid";

const UpdateISIRCommentCodesdetails = ({ onClose, selectedCommentRows, accessFlag }) => {
  const { t } = useTranslation(["translation", "financialAid", "financialAidHeadcells"]);
  const classess = useStyles();

  const selectedRow = useMemo(() => {
    if (Array.isArray(selectedCommentRows) && selectedCommentRows.length > 0) {
      return selectedCommentRows[0];
    }
    return null;
  }, [selectedCommentRows]);

  const initialValues = useMemo(
    () => ({
      commentCode: selectedRow?.commentCode || "",
      comment: selectedRow?.comment || "",
      resolved: selectedRow?.resolved === true || selectedRow?.resolved === "Y",
      note: selectedRow?.note || "",
    }),
    [selectedRow]
  );

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (!selectedRow?.id) {
        return;
      }

      const payload = {
        id: selectedRow.id,
        resolved: values.resolved,
        note: values.note,
      };

      await postApi(isir_update_comment_code_details, payload);
      toastMessage(t("popupMessages.successIcon"), t("popupMessages.success"), t("popupMessages.successfullySaved"));
      onClose(false);
    },
  });

  return (
    <>
      <PopupHeader
        title={t("commonLabel.updateISIRCommentCodesdetails", { ns: "financialAid" })}
        navigationList={financialAid_updateISIRCommentCodeDetail}
        onClose={onClose}
      />
      <form className={classess.root} onSubmit={formik.handleSubmit}>
        <Card>
          <CardContent>
            <FormGroup>
              <TextInput
                disabled
                label={t("commentcodesforISR.commentCode", { ns: "financialAidHeadcells" })}
                labelId="commentCode"
                formikValue={formik.values.commentCode}
                formikChange={formik.handleChange}
                isDoubled
              />
              <CheckBoxInput isDoubled
                label={t("commentcodesforISR.resolved", { ns: "financialAidHeadcells" })}
                labelId="resolved"
                formikValue={formik.values.resolved}
                formikChange={formik.handleChange}
                disabled={accessFlag}
                checked={formik.values.resolved}
              />
            </FormGroup>

            <FormGroup>
              <FormInputWrapper isTripple className={"tripplesize"}>
                <InputLabel htmlFor="comment">{t("commentcodesforISR.comment", { ns: "financialAidHeadcells" })}</InputLabel>
                <TextareaAutosize
                  disabled
                  aria-label="minimum height"
                  maxRows={10}
                  minRows={3}
                  name="comment"
                  onChange={formik.handleChange}
                  value={formik.values.comment}
                  style={{ width: "100%", padding: "16px", boxSizing: "border-box" }}
                />
              </FormInputWrapper>
            </FormGroup>

            <Splitter height={"10px"} />

            <FormGroup>
              <FormInputWrapper isTripple className={"tripplesize"}>
                <InputLabel htmlFor="note">{t("commentcodesforISR.note", { ns: "financialAidHeadcells" })}</InputLabel>
                <TextareaAutosize
                  disabled={accessFlag}
                  aria-label="minimum height"
                  maxRows={10}
                  minRows={3}
                  name="note"
                  onChange={formik.handleChange}
                  value={formik.values.note}
                  style={{ width: "100%", padding: "16px", boxSizing: "border-box" }}
                />
              </FormInputWrapper>
            </FormGroup>

            <div style={{ display: "flex", justifyContent: "space-between", marginRight: "35px" }}>
              <Tooltips flag={(selectedRow !== '') ? true : false} row={(selectedRow !== '') ? {
                                    insertUserID: '',
                                    insertTime: '',
                                    updateUserID: selectedRow?.updateUserID,
                                    updateTime: selectedRow?.uPdateTime || selectedRow?.updateTime
                                } : ''} />
              <ButtonWrapperFilter>
                <Button disabled={accessFlag} 
                  className="BgYellowOrange search" 
                  variant="contained" 
                  size="large" 
                  type="submit">
                  {t("buttonLabel.update", { ns: "financialAid" })}
                </Button>
                <Button
                    aria-label={"Cancel"}
                    className="BgLightBlue"
                    variant="contained"
                    size="large"
                    onClick={() => onClose("")}
                >
                    {t("buttonLabel.cancel", { ns: "financialAid" })}
                </Button>                
              </ButtonWrapperFilter>
            </div>
          </CardContent>
        </Card>
      </form>
    </>
  );
};

export default UpdateISIRCommentCodesdetails;